import type { MotifComponent, MotifComponentProps } from '../../motif';
import { m } from '../../motif/m';

export const widthVars = {
  '--carousel-card-border-width': '0',
  '--carousel-card-border-radius': m('--border-radius-l'),
  '--carousel-card-box-shadow': m('--box-shadow-s'),
  '--carousel-card-hover-box-shadow': m('--box-shadow-l'),
  '--carousel-card-landscape-square-desktop-width': '364px',
  '--carousel-card-landscape-square-mobile-width': '311px',
  '--carousel-card-landscape-square-small-mobile-width': '288px',
  '--carousel-card-portrait-desktop-width': '257px',
  '--carousel-card-portrait-mobile-width': '257px',
  '--carousel-card-desktop-grid-gap': '64px',
  '--carousel-card-mobile-grid-gap': '16px',
  '--carousel-card-desktop-text-align': 'start',
  '--carousel-card-mobile-text-align': 'start',
  '--carousel-card-desktop-text-height': '120px',
  '--carousel-card-desktop-text-min-height': '120px',
  '--carousel-card-mobile-text-height': '120px',
  '--carousel-card-mobile-text-min-height': '120px',
  '--carousel-card-desktop-text-padding': m('--spacing-m'),
  '--carousel-card-mobile-text-padding': m('--spacing-m'),
  '--carousel-card-text-position': 'absolute',
};

export const defaultCardColors = {
  '--carousel-card-border-color': m('--neutral-v0'),
  '--carousel-card-hover-border-color': m('--neutral-v0'),
  '--carousel-card-bg-color': m('--neutral-v0'),
  '--carousel-card-hover-bg-color': m('--neutral-v0'),
  '--carousel-card-fg-color': m('--neutral-v700'),
  '--carousel-inactive-dot-color': 'rgba(133, 141, 148, 0.50)',
};

export const contrastBlackCarouselVars: MotifComponentProps<MotifComponent.CAROUSEL> = {
  '--carousel-active-dot-color': m('--neutral-v0'),
  ...defaultCardColors,
  '--carousel-card-bg-color': m('--neutral-v625'),
  '--carousel-card-hover-bg-color': m('--neutral-v625'),
  '--carousel-card-fg-color': m('--neutral-v0'),
  ...widthVars,
  '--carousel-card-box-shadow': '0px 0px 0px 0 rgba(0, 0, 0, 0)',
  '--carousel-card-hover-box-shadow': '0px 0px 0px 0 rgba(0, 0, 0, 0)',
};

export const contrastYellowCarouselVars: MotifComponentProps<MotifComponent.CAROUSEL> = {
  '--carousel-active-dot-color': m('--neutral-v700'),
  ...defaultCardColors,
  ...widthVars,
};

export const contrastWhiteCarouselVars: MotifComponentProps<MotifComponent.CAROUSEL> = {
  '--carousel-active-dot-color': m('--neutral-v700'),
  ...defaultCardColors,
  ...widthVars,
};

export const contrastGrayCarouselVars: MotifComponentProps<MotifComponent.CAROUSEL> = {
  '--carousel-active-dot-color': m('--neutral-v700'),
  ...defaultCardColors,
  ...widthVars,
};
